/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClusterStateSchema } from './ClusterStateSchema';
import {
    ClusterStateSchemaFromJSON,
    ClusterStateSchemaFromJSONTyped,
    ClusterStateSchemaToJSON,
} from './ClusterStateSchema';

/**
 * 
 * @export
 * @interface CreateClusterResponse
 */
export interface CreateClusterResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateClusterResponse
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateClusterResponse
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateClusterResponse
     */
    updated: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterResponse
     */
    accountId: number;
    /**
     * 
     * @type {ClusterStateSchema}
     * @memberof CreateClusterResponse
     */
    currentState: ClusterStateSchema;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterResponse
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClusterResponse
     */
    existing: boolean;
}

/**
 * Check if a given object implements the CreateClusterResponse interface.
 */
export function instanceOfCreateClusterResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "currentState" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "existing" in value;

    return isInstance;
}

export function CreateClusterResponseFromJSON(json: any): CreateClusterResponse {
    return CreateClusterResponseFromJSONTyped(json, false);
}

export function CreateClusterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClusterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'accountId': json['account_id'],
        'currentState': ClusterStateSchemaFromJSON(json['current_state']),
        'name': json['name'],
        'existing': json['existing'],
    };
}

export function CreateClusterResponseToJSON(value?: CreateClusterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'account_id': value.accountId,
        'current_state': ClusterStateSchemaToJSON(value.currentState),
        'name': value.name,
        'existing': value.existing,
    };
}

